import { Trans } from "@lingui/react/macro";
import { FilledButton } from "../Button/Button";

export const MarkAsReadButton = ({
  markAsRead,
}: {
  markAsRead: () => void;
}) => {
  return (
    <FilledButton onClick={markAsRead}>
      <Trans>Markera som läst</Trans>
    </FilledButton>
  );
};
